export function formatDate(dateString, { seconds = false, shortYear = true } = {}) {
    if (!dateString) {
        return '-';
    }
    const date = new Date(dateString);
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: shortYear ? '2-digit' : 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    };
    if (seconds) {
        options.second = '2-digit';
    }
    return date.toLocaleString('nl-NL', options);
}

export function formatDateShort(dateString) {
    if (!dateString) {
        return '-';
    }
    const date = new Date(dateString);
    return date.toLocaleDateString('nl-NL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}

export function formatMoney(amount) {
    if (amount == null) {
        return '-';
    }
    return Number(amount).toLocaleString('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}
